<template>
  <div>
    <director_app_bar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        :title="
          'รายงานตัวเลือกสถานศึกษา ตำแหน่ง ผู้อำนวยการ ครั้งที่ : ' +
            (period_sedirectors.period_sedirector_times || '-') +
            ' ปี : ' +
            (period_sedirectors.period_sedirector_year || '-')
        "
      >
        <v-card>
          <v-simple-table>
            <tbody>
              <tr>
                <td class="text-center">
                  รอบที่ {{ period_sedirectors.period_sedirector_round }}
                </td>
                <td class="text-center">
                  ลำดับที่ {{ period_sedirectors.period_sedirector_idstart }} -
                  {{ period_sedirectors.period_sedirector_idend }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-card class="pa-1">
          <v-simple-table>
            <tbody>
              <tr>
                <td class="text-center">
                  <h3 class="font-weight-bold" color="info">
                    จำนวนผู้ผ่านการคัดเลือก :
                    {{ sedirector_appCount.sumAll }}
                    คน
                  </h3>
                </td>
                <td class="text-center">
                  <h3 class="font-weight-bold" color="info">
                    สละสิทธิ์ :
                    {{ sedirector_appCount.disclaims }}

                    คน
                  </h3>
                </td>

                <td class="text-center">
                  <v-btn
                    rounded
                    color="info"
                    :href="
                      '#/admin/print_director_app_score_choose/?times=' +
                        period_sedirectors.period_sedirector_times +
                        '&years=' +
                        period_sedirectors.period_sedirector_year
                    "
                    target="_blank"
                    ><v-icon>mdi-printer</v-icon>ส่งออกข้อมูลผู้สมัคร
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td class="text-center">
                  <h3 class="font-weight-bold">
                    เลือกวิทยาลัยเสร็จสิ้น :
                    {{ sedirector_appCount.sedirector_app_collegeapps }}

                    คน
                  </h3>
                </td>
                <td class="text-center">
                  <h3 class="font-weight-bold">
                    ยังไม่ได้ทำรายการ :

                    {{ sedirector_appCount.dontChoose }}

                    คน
                  </h3>
                </td>
                <td class="text-center">
                  <v-btn rounded color="success" @click="noticeSedirector()"
                    ><v-icon>mdi-checkbox-marked-circle-outline</v-icon>ประกาศผล
                  </v-btn>
                </td>
              </tr>

              <tr>
                <td colspan="2" class="text-center">
                  <span class="grey--text">
                    กรณีประมวลผลการคัดเลือกและบรรจุนอกระบบ
                    นำเข้าผู้ได้รับการบรรจุและสถานศึกษาที่บรรจุจากไฟล์ CSV
                  </span>
                </td>
                <td class="text-center">
                  <v-btn rounded color="primary" @click="openImportDialog()"
                    ><v-icon>mdi-file-upload</v-icon>นำเข้าผลการบรรจุ (CSV)
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table></v-card
        >

        <v-select
          v-model="selectedHeaders"
          :items="headers"
          label="เลือกคอลัมน์ที่ต้องการแสดง"
          multiple
          outlined
          return-object
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 6">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 6" class="grey--text caption"
              >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
            >
          </template>
        </v-select>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
          single-line
          hide-details
          dense
          filled
          class="mb-2"
        />
        <v-data-table
          color="success"
          :loading="loading"
          :headers="showHeaders"
          :items="sedirector_apps"
          :search="search"
          item-key="sedirector_app_idref"
        >
          <template v-slot:item.actions="{ item }">
            <div
              v-if="
                item.sedirector_app_collegeapp_status === 'send' ||
                  item.sedirector_app_collegeapp_status === 'receipt'
              "
            >
              <v-icon color="warning">mdi-cube-send</v-icon>
            </div>
            <div v-else>
              <div
                v-if="item.sedirector_app_id === editedItem.sedirector_app_id"
              >
                <v-icon color="error" class="mr-3" @click="close">
                  mdi-window-close
                </v-icon>
                <v-icon color="success" v-if="editedItem.sedirector_app_collegeapp && editedItem.sedirector_app_collegeapp_idpositions" @click="save()">
                  mdi-content-save
                </v-icon>
              </div>
              <div v-else>
                <v-icon color="success" class="mr-3" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon
                  color="error"
                  @click="deleteItem(item.sedirector_app_idref)"
                >
                  mdi-delete
                </v-icon>
              </div>
            </div>
          </template>

          <template v-slot:item.sedirector_app_collegeapp="{ item }">
            <v-autocomplete
              v-model="editedItem.sedirector_app_collegeapp"
              label="วิทยาลัย"
              :items="director_college_manpowers"
              item-text="college_namemain"
              item-value="dcm_college_code"
              v-if="item.sedirector_app_id === editedItem.sedirector_app_id"
              :rules="[v => !!v || '']"
              @change="director_college_manpowerQueryID()"
            >
            <template v-slot:item="{item}">
            <div>
              <div class="font-weight-bold">
                {{ item.college_namemain }}
              </div>
              <div>
                {{ item.province_name }}
              </div>
            </div>
          </template>
        </v-autocomplete>
            <div v-else>
              <v-chip v-if="item.sedirector_app_collegeapp" color="success">
                {{ item.collegenameChoose }}</v-chip
              >
              <v-chip color="grey" dark v-else>
                {{ item.collegenameChoose || "-" }}
              </v-chip>
            </div>
          </template>

          <template
            v-slot:item.sedirector_app_collegeapp_idpositions="{ item }"
          >
            <v-autocomplete
              v-model="editedItem.sedirector_app_collegeapp_idpositions"
              label="เลขที่ตำแหน่ง"
              :items="director_college_manpower_idpositions"
              item-text="dcm_idpositons"
              item-value="dcm_idpositons"
              v-if="item.sedirector_app_id === editedItem.sedirector_app_id"
              :rules="[v => !!v || '']"
            >
              <template v-slot:item="{ item }">
                <div>
                  <div>
                    {{ item.dcm_idpositons }}
                  </div>
                  <div>: {{ item.whoBooking }}</div>
                </div>
              </template>
            </v-autocomplete>
            <div v-else>
              <v-chip
                v-if="item.sedirector_app_collegeapp_idpositions"
                color="success"
              >
                {{ item.sedirector_app_collegeapp_idpositions }}</v-chip
              >
              <v-chip color="grey" dark v-else>
                {{ item.sedirector_app_collegeapp_idpositions || "-" }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.sedirector_app_status_report="{ item }">
            <div
              v-if="
                item.sedirector_app_collegeapp_status === 'send' ||
                  item.sedirector_app_collegeapp_status === 'receipt'
              "
            >
              <v-icon color="warning">mdi-cube-send</v-icon>
            </div>
            <div v-else>
              <v-btn
                @click="updatesedirector_apps(item.sedirector_app_idref)"
                rounded
                fab
                small
                color="warning"
                ><v-icon>mdi-pencil</v-icon></v-btn
              >
            </div>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!-- นำเข้าผลการบรรจุ ผอ. จากไฟล์ CSV -->
      <v-dialog v-model="importDialog" max-width="95%" persistent>
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon dark class="mr-2">mdi-file-upload</v-icon>
            นำเข้าผลการบรรจุตำแหน่ง ผู้อำนวยการ ปี
            {{ period_sedirectors.period_sedirector_year }} ครั้งที่
            {{ period_sedirectors.period_sedirector_times }}
            <v-spacer />
            <v-btn icon dark :disabled="importLoading" @click="closeImportDialog()"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>

          <v-card-text class="pt-4">
            <v-alert type="info" dense outlined>
              คอลัมน์ตามลำดับ: ลำดับที่, ชื่อ - นามสกุล, เลขบัตรประชาชน,
              รหัสสถานศึกษาเดิม, วิทยาลัยเดิม, ตำแหน่งเลขที่เดิม,
              รหัสสถานศึกษาใหม่, วิทยาลัยใหม่, ตำแหน่งเลขที่ใหม่ (แถวแรกเป็นหัวตาราง)
              — ระบบจะบันทึกสถานะ "ได้รับการบรรจุ" สถานศึกษาและเลขที่ตำแหน่งที่บรรจุ
              และจองตำแหน่งว่าง ผอ. ให้อัตโนมัติ
              <v-btn small text color="primary" @click="downloadImportTemplate()"
                ><v-icon small>mdi-download</v-icon>ดาวน์โหลดแบบฟอร์ม</v-btn
              >
            </v-alert>

            <v-file-input
              v-model="importFile"
              accept=".csv,text/csv"
              label="เลือกไฟล์ CSV (UTF-8 หรือ Windows-874)"
              outlined
              dense
              show-size
              :disabled="importLoading"
              @change="onImportFileChange"
            />

            <v-row v-if="importRawRows.length" dense align="center">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="importNoOffset"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  label="บวกเพิ่มลำดับที่ในไฟล์"
                  :disabled="importLoading"
                  @change="applyImportOffset()"
                />
              </v-col>
              <v-col cols="12" md="8" class="caption">
                ลำดับที่ในไฟล์ {{ importNoRange.min }} - {{ importNoRange.max }}
                → บันทึกเป็นลำดับที่ในบัญชี
                <b>{{ importNoRange.min + (importNoOffset || 0) }} -
                  {{ importNoRange.max + (importNoOffset || 0) }}</b>
                (รอบที่ {{ period_sedirectors.period_sedirector_round }}
                ใช้ลำดับที่ {{ period_sedirectors.period_sedirector_idstart }} -
                {{ period_sedirectors.period_sedirector_idend }})
              </v-col>
            </v-row>

            <div v-if="importPreview" class="mt-3">
              <v-chip class="mr-2" color="grey" dark
                >ทั้งหมด {{ importPreview.summary.total }}</v-chip
              >
              <v-chip class="mr-2" color="success"
                >ถูกต้อง {{ importPreview.summary.ok }}</v-chip
              >
              <v-chip class="mr-2" color="warning"
                >คำเตือน {{ importPreview.summary.warning }}</v-chip
              >
              <v-chip class="mr-2" color="error"
                >ผิดพลาด {{ importPreview.summary.error }}</v-chip
              >

              <v-alert
                v-if="importPreview.not_in_file && importPreview.not_in_file.length"
                type="warning"
                dense
                text
                class="mt-3"
              >
                มีผู้ได้รับการบรรจุในระบบรอบนี้ที่ไม่อยู่ในไฟล์
                {{ importPreview.not_in_file.length }} คน (ระบบไม่แก้ไขให้):
                {{ importPreview.not_in_file.map(o => o.fullname).join(", ") }}
              </v-alert>

              <v-data-table
                class="mt-3"
                dense
                :headers="importHeaders"
                :items="importPreview.rows"
                item-key="line"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:item.state="{ item }">
                  <v-icon v-if="item.state === 'ok'" color="success"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon v-else-if="item.state === 'warning'" color="warning"
                    >mdi-alert</v-icon
                  >
                  <v-icon v-else color="error">mdi-close-circle</v-icon>
                </template>
                <template v-slot:item.fullname="{ item }">
                  <div>{{ item.fullname }}</div>
                  <div class="caption grey--text">{{ item.idcard }}</div>
                </template>
                <template v-slot:item.old="{ item }">
                  <div>{{ item.old_college_name || item.old_college_code }}</div>
                  <div class="caption grey--text">
                    ตำแหน่ง {{ item.old_idposition || "-" }}
                  </div>
                </template>
                <template v-slot:item.new="{ item }">
                  <div class="font-weight-bold">
                    {{ item.new_college_name || item.new_college_code }}
                  </div>
                  <div class="caption">ตำแหน่ง {{ item.new_idposition }}</div>
                </template>
                <template v-slot:item.messages="{ item }">
                  <div
                    v-for="(m, i) in item.errors"
                    :key="'e' + i"
                    class="error--text caption"
                  >
                    • {{ m }}
                  </div>
                  <div
                    v-for="(m, i) in item.warnings"
                    :key="'w' + i"
                    class="orange--text text--darken-3 caption"
                  >
                    • {{ m }}
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="importLoading" @click="closeImportDialog()"
              >ปิด</v-btn
            >
            <v-btn
              color="primary"
              :loading="importLoading"
              :disabled="
                !importPreview ||
                  importPreview.summary.total === 0 ||
                  importPreview.summary.error > 0
              "
              @click="commitImport()"
              ><v-icon>mdi-content-save</v-icon>ยืนยันนำเข้าข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- V-model sedirector_app_score_c1_filedialog -->
      <v-layout row justify-center>
        <v-dialog v-model="sedirector_app_score_c1_filedialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="'/HrvecRegisDir/' + pdffiles"
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import director_app_bar from "../../../components/admin/director/director_app_bar";

export default {
  data() {
    return {
      value: "2",
      loading: false,
      ApiKey: "HRvec2021",
      sedirector_app_idref: [],
      valid: true,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      sedirector_apps: [],

      search: "",
      pagination: {},
      selected: [],
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "จังหวัด", align: "center", value: "province_name" },
        {
          text: "ลำดับที่",
          align: "center",
          value: "sedirector_app_idnoaccount"
        },
        {
          text: "รหัสบัตรประชาชน",
          align: "center",
          value: "sedirector_app_idcard"
        },
        { text: "ชื่อ-นามสกุล", align: "left", value: "fristnames" },
        { text: "สถานศึกษาเดิม", align: "left", value: "college_name_old" },
        { text: "ตำแหน่งเลขที่เดิม", align: "center", value: "id_position" },
        { text: "เลือก", align: "center", value: "actions" },

        {
          text: "เลือกวิทยาลัย",
          align: "center",
          value: "sedirector_app_collegeapp"
        },
        {
          text: "เลขที่ตำแหน่ง",
          align: "center",
          value: "sedirector_app_collegeapp_idpositions"
        },

        {
          text: "สถานะ",
          align: "center",
          value: "sedirector_app_status_report"
        }
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],

      sedirector_apps_id_ref: [],

      period_sedirectors: [],
      sedirector_appCount: {},
      rules: [
        value => !value || value.size < 5242880 || "ไฟล์ไม่เกิน 5 MB / 5120 KB",
        value => !!value || ""
      ],
      pdffiles: "",
      sedirector_app_score_c1_filedialog: false,
      editedIndex: -1,
      editedItem: {
        sedirector_app_id: 0,
        statusAdd: ""
      },
      editedItemUpdate: {},
      defaultItem: {
        sedirector_app_id: 0,
        statusAdd: "add"
      },

      deletedItemmat: {},
      deletedItemmcm: {},
      sedirector_appsidrefs: [],
      director_college_manpowers: [],
      director_college_manpower_idpositions: [],
      update_director_college_manpowers: {},
      update_sedirector_app_notice: {},

      importDialog: false,
      importFile: null,
      importRows: [],
      importRawRows: [],
      importNoOffset: 0,
      importPreview: null,
      importLoading: false,
      importHeaders: [
        { text: "", value: "state", sortable: false },
        { text: "ลำดับที่", value: "no", align: "center" },
        { text: "ชื่อ-นามสกุล / เลขบัตร", value: "fullname" },
        { text: "สถานศึกษาเดิม", value: "old", sortable: false },
        { text: "สถานศึกษาที่บรรจุ", value: "new", sortable: false },
        { text: "ผลการตรวจสอบ", value: "messages", sortable: false }
      ]
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.period_sedirectorQuery();
    
  },
  methods: {
    async editItem(item) {
      this.editedIndex = this.sedirector_apps.indexOf(item);
      this.editedItem = Object.assign({}, item);

      let result = await this.$http.post("sedirector_app_dir.php", {
        ApiKey: this.ApiKey,
        sedirector_app_idref: item.sedirector_app_idref
      });
      this.sedirector_appsidrefs = result.data;
      await this.director_college_manpowerQuery();
    },

    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      this.editedItem.ApiKey = this.ApiKey;
      Object.assign(this.sedirector_apps[this.editedIndex], this.editedItem);

      let result = await this.$http.post(
        "sedirector_app.update.php",
        this.editedItem
      );

      this.update_director_college_manpowers.ApiKey = this.ApiKey;
      this.update_director_college_manpowers.dcm_times = this.period_sedirectors.period_sedirector_times;
      this.update_director_college_manpowers.dcm_years = this.period_sedirectors.period_sedirector_year;
      this.update_director_college_manpowers.dcm_idpositons = this.editedItem.sedirector_app_collegeapp_idpositions;
      this.update_director_college_manpowers.dcm_id_card_booking = this.editedItem.sedirector_app_idcard;

      let result_man = await this.$http.post(
        "director_college_manpower.update.php",
        this.update_director_college_manpowers
      );

      if (result.data.status == true && result_man.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ทำรายการซ้ำ",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.sedirector_appQueryAll();
      this.close();
    },
    async deleteItem(sedirector_app_idref) {
      let result = await this.$http.post("sedirector_app_dir.php", {
        ApiKey: this.ApiKey,
        sedirector_app_idref: sedirector_app_idref
      });
      this.sedirector_appsidrefs = result.data;

      let fristnames = this.sedirector_appsidrefs.fristnames;
      Swal.fire({
        title: "คุณต้องการยกเลิกคะแนนรายการนี้?",
        text: fristnames,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ลบรายการ",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.update_director_college_manpowers.ApiKey = this.ApiKey;
          this.update_director_college_manpowers.dcm_times = this.period_sedirectors.period_sedirector_times;
          this.update_director_college_manpowers.dcm_years = this.period_sedirectors.period_sedirector_year;
          this.update_director_college_manpowers.dcm_idpositons = this.sedirector_appsidrefs.sedirector_app_collegeapp_idpositions;
          this.update_director_college_manpowers.dcm_id_card_booking = "";

          let result_man = await this.$http.post(
            "director_college_manpowerID.update.php",
            this.update_director_college_manpowers
          );

          this.sedirector_appsidrefs.ApiKey = this.ApiKey;
          this.sedirector_appsidrefs.sedirector_app_collegeapp = "";
          this.sedirector_appsidrefs.sedirector_app_collegeapp_idpositions = "";

          let resultupdatemat = await this.$http.post(
            "sedirector_app.update.php",
            this.sedirector_appsidrefs
          );
        }
        this.sedirector_appQueryAll();
      });
    },

    async director_college_manpowerQuery() {
      let result = await this.$http.post("director_college_manpower.php", {
        ApiKey: this.ApiKey,
        dcm_types: "ผอ.",
        dcm_times: this.period_sedirectors.period_sedirector_times,
        dcm_years: this.period_sedirectors.period_sedirector_year,
        dcm_id_card_booking: "Ok"
      });
      this.director_college_manpowers = result.data;
    },

    async director_college_manpowerQueryID() {
      let result = await this.$http.post("director_college_manpower.php", {
        ApiKey: this.ApiKey,
        dcm_types: "ผอ.",
        dcm_times: this.period_sedirectors.period_sedirector_times,
        dcm_years: this.period_sedirectors.period_sedirector_year,
        dcm_college_code: this.editedItem.sedirector_app_collegeapp
      });
      this.director_college_manpower_idpositions = result.data;
    },

    async updatesedirector_apps(sedirector_app_idref) {
      let result_con = await this.$http.post("sedirector_app_dir.php", {
        ApiKey: this.ApiKey,
        sedirector_app_idref: sedirector_app_idref
      });
      this.sedirector_apps_id_ref = result_con.data;
      let text = this.sedirector_apps_id_ref.fristnames;
      Swal.fire({
        title: "รายการนี้สละสิทธิ์ ?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ขอยกเลิก",
        cancelButtonText: "ปิด"
      }).then(async result => {
        if (result.isConfirmed) {
          let result;
          this.sedirector_apps_id_ref.ApiKey = this.ApiKey;
          this.sedirector_apps_id_ref.sedirector_app_status_report = "disclaim";
          result = await this.$http.post(
            "sedirector_app.update.php",
            this.sedirector_apps_id_ref
          );
          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.sedirector_appQueryAll();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    async noticeSedirector() {
      Swal.fire({
        title: "ประกาศผลการเลือกสถานศึกษา ?",
        text: "แจ้งวิทยาลัยปลายทางทราบ และรับรายงานตัว",
        icon: "warning",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ประกาศ",
        cancelButtonText: "ยกเลิก",
        denyButtonText: `ยกเลิกประกาศ`
      }).then(async result => {
        if (result.isConfirmed) {
          let result;
          this.update_sedirector_app_notice.ApiKey = this.ApiKey;
          this.update_sedirector_app_notice.sedirector_app_year = this.period_sedirectors.period_sedirector_year;
          this.update_sedirector_app_notice.sedirector_app_time = this.period_sedirectors.period_sedirector_times;
          this.update_sedirector_app_notice.sedirector_app_ptype = 3;
          this.update_sedirector_app_notice.sedirector_app_collegeapp_status ="send";
          this.update_sedirector_app_notice.period_sedirector_idstart =this.period_sedirectors.period_sedirector_idstart;
          this.update_sedirector_app_notice.period_sedirector_idend =this.period_sedirectors.period_sedirector_idend;        

          result = await this.$http.post(
            "sedirector_appApprove.update.php",
            this.update_sedirector_app_notice
          );

          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.sedirector_appQueryAll();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        } else if (result.isDenied) {
          let result;
          this.update_sedirector_app_notice.ApiKey = this.ApiKey;
          this.update_sedirector_app_notice.sedirector_app_year = this.period_sedirectors.period_sedirector_year;
          this.update_sedirector_app_notice.sedirector_app_time = this.period_sedirectors.period_sedirector_times;
          this.update_sedirector_app_notice.sedirector_app_collegeapp_status =
            "";
          result = await this.$http.post(
            "sedirector_appApprove.update.php",
            this.update_sedirector_app_notice
          );

          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.sedirector_appQueryAll();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },


    async period_sedirectorQuery() {
      let result_period_sedirector;
      result_period_sedirector = await this.$http.post(
        "period_sedirector.php",
        {
          ApiKey: this.ApiKey,
          period_sedirector_process: "1",
          period_sedirector_id: "207"
        }
      );
      this.period_sedirectors = result_period_sedirector.data;
      if(this.period_sedirectors.period_sedirector_process==='1' || this.period_sedirectors.period_sedirector_process===1){
        await this.sedirector_appQueryAll();
      }
    },

    async sedirector_appQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("sedirector_app_dir.php", {
          ApiKey: this.ApiKey,
          sedirector_app_ptype: 3,
          sedirector_app_time: this.period_sedirectors.period_sedirector_times,
          sedirector_app_year: this.period_sedirectors.period_sedirector_year,
          sedirector_app_ipastatus: "guarantee",
          period_sedirector_idstart: this.period_sedirectors
            .period_sedirector_idstart,
          period_sedirector_idend: this.period_sedirectors
            .period_sedirector_idend
        })
        .finally(() => (this.loading = false));
      this.sedirector_apps = result.data;

      let data = this.sedirector_apps;
      let sum = 0;
      let sedirector_app_collegeapps = 0;
      let disclaims = 0;
      let dontChoose = 0;
      data.forEach(value => {
        if (value.sedirector_app_ipastatus == "guarantee") {
          sum += 1;
        }
        let collegeapp = String(value.sedirector_app_collegeapp);
        if (collegeapp.length > 5) {
          sedirector_app_collegeapps += 1;
        } else {
          dontChoose += 1;
        }

        if (value.sedirector_app_status_report == "disclaim") {
          disclaims += 1;
        }
      });
      this.sedirector_appCount.sumAll = sum;
      this.sedirector_appCount.sedirector_app_collegeapps = sedirector_app_collegeapps;
      this.sedirector_appCount.disclaims = disclaims;
      this.sedirector_appCount.dontChoose = dontChoose;
    },

    openImportDialog() {
      if (!this.period_sedirectors.period_sedirector_year) {
        Swal.fire({
          icon: "warning",
          title: "ยังไม่ได้เปิดรอบรายงานตัวเลือกสถานศึกษา ผอ.",
          text: "กรุณาตรวจสอบกำหนดการ ผอ."
        });
        return;
      }
      this.importDialog = true;
    },

    closeImportDialog() {
      this.importDialog = false;
      this.importFile = null;
      this.importRows = [];
      this.importRawRows = [];
      this.importNoOffset = 0;
      this.importPreview = null;
    },

    // ไฟล์มักนับลำดับที่ 1..n แต่ลำดับที่ในบัญชีของรอบ 2 เป็นต้นไปเริ่มต่อจากรอบก่อน (เช่น 34 - 59)
    // ถ้าลำดับในไฟล์อยู่นอกช่วงของรอบ จึงเสนอค่าบวกเพิ่มให้เริ่มที่ period_sedirector_idstart
    suggestImportOffset() {
      const start = parseInt(this.period_sedirectors.period_sedirector_idstart) || 0;
      const end = parseInt(this.period_sedirectors.period_sedirector_idend) || 0;
      const { min, max } = this.importNoRange;
      if (start > 0 && (min < start || (end > 0 && max > end))) {
        return start - min;
      }
      return 0;
    },

    async applyImportOffset() {
      const offset = parseInt(this.importNoOffset) || 0;
      this.importRows = this.importRawRows.map(r =>
        Object.assign({}, r, { no: String(parseInt(r.no) + offset) })
      );
      this.previewImportResult(await this.requestImport("preview"));
    },

    downloadImportTemplate() {
      const header =
        "ลำดับที่,ชื่อ - นามสกุล,เลขบัตรประชาชน,รหัสสถานศึกษาเดิม,วิทยาลัยเดิม,ตำแหน่งเลขที่เดิม,รหัสสถานศึกษาใหม่,วิทยาลัยใหม่,ตำแหน่งเลขที่ใหม่\r\n";
      const blob = new Blob(["﻿" + header], {
        type: "text/csv;charset=utf-8"
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "แบบฟอร์มนำเข้าผลการบรรจุ_ผอ.csv";
      link.click();
      URL.revokeObjectURL(link.href);
    },

    // ไฟล์ที่บันทึกจาก Excel ภาษาไทยมักเป็น Windows-874 ถ้าถอดรหัส UTF-8 ไม่ผ่านจึงลองอีกครั้ง
    decodeCsvBuffer(buffer) {
      try {
        return new TextDecoder("utf-8", { fatal: true }).decode(buffer);
      } catch (e) {
        return new TextDecoder("windows-874").decode(buffer);
      }
    },

    parseCsv(text) {
      const rows = [];
      let row = [];
      let field = "";
      let inQuotes = false;
      text = text.replace(/^﻿/, "");
      for (let i = 0; i < text.length; i++) {
        const c = text[i];
        if (inQuotes) {
          if (c === '"' && text[i + 1] === '"') {
            field += '"';
            i++;
          } else if (c === '"') {
            inQuotes = false;
          } else {
            field += c;
          }
        } else if (c === '"') {
          inQuotes = true;
        } else if (c === ",") {
          row.push(field.trim());
          field = "";
        } else if (c === "\n" || c === "\r") {
          if (c === "\r" && text[i + 1] === "\n") i++;
          row.push(field.trim());
          rows.push(row);
          row = [];
          field = "";
        } else {
          field += c;
        }
      }
      if (field !== "" || row.length) {
        row.push(field.trim());
        rows.push(row);
      }
      return rows.filter(r => r.some(v => v !== ""));
    },

    async onImportFileChange(file) {
      this.importPreview = null;
      this.importRows = [];
      this.importRawRows = [];
      if (!file) return;

      const text = this.decodeCsvBuffer(await file.arrayBuffer());
      const lines = this.parseCsv(text);
      // หัวตารางมีชื่อคอลัมน์ซ้ำ ("ตำแหน่งเลขที่เดิม" 2 ครั้ง) จึงอ่านตามตำแหน่งคอลัมน์ ไม่อ่านตามชื่อ
      const dataLines = lines.filter(r => /^\d+$/.test(r[0]));
      const badLines = dataLines.filter(r => r.length < 9);
      if (!dataLines.length || badLines.length) {
        Swal.fire({
          icon: "error",
          title: "รูปแบบไฟล์ไม่ถูกต้อง",
          text: !dataLines.length
            ? "ไม่พบข้อมูลในไฟล์"
            : "มีแถวที่มีไม่ครบ 9 คอลัมน์ ลำดับที่ " +
              badLines.map(r => r[0]).join(", ")
        });
        return;
      }
      if (dataLines.some(r => /e\+/i.test(r[2]))) {
        Swal.fire({
          icon: "error",
          title: "เลขบัตรประชาชนถูก Excel แปลงเป็นรูปแบบวิทยาศาสตร์",
          text: "กรุณาจัดรูปแบบคอลัมน์เลขบัตรเป็นข้อความ (Text) แล้วบันทึกไฟล์ใหม่"
        });
        return;
      }

      this.importRawRows = dataLines.map(r => ({
        no: r[0],
        fullname: r[1],
        idcard: r[2],
        old_college_code: r[3],
        old_idposition: r[5],
        new_college_code: r[6],
        new_idposition: r[8]
      }));
      this.importNoOffset = this.suggestImportOffset();
      await this.applyImportOffset();
    },

    async requestImport(action) {
      this.importLoading = true;
      try {
        const result = await this.$http.post(
          "director_app_placement_import.php",
          {
            ApiKey: this.ApiKey,
            action: action,
            year: this.period_sedirectors.period_sedirector_year,
            time: this.period_sedirectors.period_sedirector_times,
            period_idstart: this.period_sedirectors.period_sedirector_idstart,
            period_idend: this.period_sedirectors.period_sedirector_idend,
            rows: this.importRows
          }
        );
        return result.data;
      } catch (e) {
        const data = (e.response && e.response.data) || {};
        return { status: false, message: data.message || "เชื่อมต่อระบบไม่สำเร็จ" };
      } finally {
        this.importLoading = false;
      }
    },

    previewImportResult(data) {
      if (data.rows) {
        this.importPreview = data;
      }
      if (!data.status) {
        Swal.fire({ icon: "error", title: data.message || "ตรวจสอบข้อมูลไม่สำเร็จ" });
      }
    },

    async commitImport() {
      const confirm = await Swal.fire({
        title: "ยืนยันนำเข้าผลการบรรจุ ?",
        text:
          "จำนวน " +
          this.importPreview.summary.total +
          " คน (คำเตือน " +
          this.importPreview.summary.warning +
          " แถว) ข้อมูลสถานศึกษาที่บรรจุเดิมของรายชื่อในไฟล์จะถูกแทนที่",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "นำเข้า",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      const data = await this.requestImport("commit");
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: data.message,
          showConfirmButton: false,
          timer: 2000
        });
        this.closeImportDialog();
        await this.sedirector_appQueryAll();
      } else {
        this.previewImportResult(data);
      }
    },

    getColor(calories) {
      if (calories > 0) return "green";
      else return "";
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    time_stamp() {
      let time = Date.now();
      return time;
    },
    period_sedirector_years() {
      let yyyy = this.period_sedirectors.period_sedirector_year;
      return yyyy;
    },
    color() {
      return "lime darken-4";
    },
    importNoRange() {
      const nos = this.importRawRows.map(r => parseInt(r.no) || 0);
      if (!nos.length) return { min: 0, max: 0 };
      return { min: Math.min(...nos), max: Math.max(...nos) };
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  },
  components: { director_app_bar }
};
</script>

<style scoped>
.orange {
  background-color: rgb(236, 194, 115);
}
</style>
